import { MouseEvent, TouchEvent } from 'react';

export type UIEvent<T extends Element> = MouseEvent<T> | TouchEvent<T> | PointerEvent;

export const isTouchEvent = (event: UIEvent<Element>): event is TouchEvent<Element> => {
  return (event as TouchEvent<Element>).changedTouches !== undefined;
};
export const isPointerEvent = (event: UIEvent<Element>): event is PointerEvent => {
  return (event as PointerEvent).isPrimary !== undefined;
};

export const getPageX = (event: UIEvent<Element>): number => {
  if (isTouchEvent(event)) {
    return event.changedTouches[0].pageX;
  }

  return event.pageX;
};

export const getPageY = (event: UIEvent<Element>): number => {
  if (isTouchEvent(event)) {
    return event.changedTouches[0].pageY;
  }

  return event.pageY;
};
